export default (record: any) => {
  const { complianceDetails, addresses, ...newRecord } = record;
  newRecord.mid = complianceDetails?.us?.mid;
  newRecord.address = addresses?.mailing || addresses?.physical;
  return newRecord;
};
